import { render, staticRenderFns } from "./ReporteImpuestos.vue?vue&type=template&id=2cfa0897&"
import script from "./ReporteImpuestos.vue?vue&type=script&lang=js&"
export * from "./ReporteImpuestos.vue?vue&type=script&lang=js&"
import style0 from "./ReporteImpuestos.vue?vue&type=style&index=0&id=2cfa0897&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports